import React, { FC } from 'react';
import { Checkbox, Form } from 'antd';

// Styles
import './status-filter.scss';

type TStatusFilterProps = { };

export const StatusFilter: FC<TStatusFilterProps> = (
  { }: TStatusFilterProps
) => {

  const options = [
    { value: 'active', label: 'Active' },
    { value: 'in_active', label: 'Inactive' },
    // TODO next release
    // { value: 'archived', label: 'Archived' },
  ];

  return (
    <div className="status-filter">
      <Form.Item name={ 'status' }>
        <Checkbox.Group options={ options }/>
      </Form.Item>
    </div>
  );
}
